import React from 'react'
import FlexBox from './FlexBox'
import RowFlexBox from './RowFlexBox'

const Gender = ({gender, percentage}) => {
  const classForGender = `mini-dmp-icons gender-${gender}`
  return (
    <FlexBox>
      <RowFlexBox>
        {gender}
      </RowFlexBox>
      <RowFlexBox className='gender-details'>
        <FlexBox className='gender-percentage'>
          <span className={classForGender} />
          {percentage}%
                </FlexBox>
      </RowFlexBox>
    </FlexBox>
  )
}

export default Gender



// WEBPACK FOOTER //
// ../src/commons/components/SegmentsPopupContent/Gender.js